import { AppBar, Avatar, Toolbar } from '@mui/material';
import { SpotlightSearch } from 'components';
import ProfileOptions from 'components/Navigation/ProfileOptions';
import Logo from '../../../src/images/1Tul-logo.png';
import * as React from 'react';
import { useContext, useMemo } from 'react';
import { Link } from 'react-router-dom';
import SecondaryNavigation from './SecondaryNavigation';
import { OrganizationsContext } from '../../contexts/OrganizationsContext';
import { useSelector } from 'react-redux';
import { primaryOrganizationUuidSelector, primarySportSelector } from '../../redux/reducers/user';
import PrimarySportQuickSelect from './PrimarySportQuickSelect';

const MobileTopNavigation = () => {
    const organizationsContext = useContext(OrganizationsContext);
    const primaryOrganizationUuid = useSelector(primaryOrganizationUuidSelector);
    const primarySport = useSelector(primarySportSelector);
    const shouldPromptPrimarySport = !primarySport;

    // Find the primary organization
    const primaryOrganization = useMemo(() => {
        const organizations = organizationsContext?.organizations || [];
        if (!primaryOrganizationUuid || !organizations || organizations.length === 0) {
            return null;
        }
        const found = organizations.find((org) => org.uuid === primaryOrganizationUuid);
        return found || null;
    }, [primaryOrganizationUuid, organizationsContext]);

    // No need to generate URL - use logo_url directly like other components do

    return (
        <AppBar position={'relative'} component="header">
            <Toolbar style={{ justifyContent: 'space-between' }}>
                {primaryOrganization?.logo_url ? (
                    <Link to={`/organizations/${primaryOrganization.uuid}`}>
                        <Avatar
                            variant="rounded"
                            src={primaryOrganization.logo_url || ''}
                            alt={primaryOrganization.name}
                            sx={{
                                width: 60,
                                height: 60,
                                cursor: 'pointer',
                            }}
                        />
                    </Link>
                ) : (
                    <Link to="/home/training-dashboard">
                        <img
                            src={Logo}
                            alt="1TUL Logo"
                            width={60}
                            height={60}
                            style={{
                                display: 'block',
                                visibility: 'visible',
                            }}
                        />
                    </Link>
                )}
                <SpotlightSearch />
                {shouldPromptPrimarySport && <PrimarySportQuickSelect compact />}
                <ProfileOptions className="" />
            </Toolbar>
            <SecondaryNavigation />
        </AppBar>
    );
};
export default MobileTopNavigation;
